var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.spver === 1 ? "img-default-film" : "img-default-sogou" },
    [
      _vm.lazy
        ? _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.src,
                expression: "src",
              },
            ],
            on: { error: _vm.imgerr },
          })
        : _c("img", { attrs: { src: _vm.src }, on: { error: _vm.imgerr } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }